import React from 'react'
import { useNavigate } from 'react-router-dom'

// One cell in the catalog matrix grid. Background intensity scales with
// count (relative to the matrix's max). Hovering shows a tooltip with
// the preview titles. Clicking navigates to /catalog with both dimension
// filters preselected.
function intensityClasses(count, maxCount) {
  if (!count || count === 0) return 'bg-slate-50 text-slate-300'
  if (!maxCount || maxCount === 0) return 'bg-slate-50 text-slate-300'

  const ratio = count / maxCount
  if (ratio > 0.8)  return 'bg-accent-700  text-white'
  if (ratio > 0.6)  return 'bg-accent-600  text-white'
  if (ratio > 0.4)  return 'bg-accent-500  text-white'
  if (ratio > 0.25) return 'bg-accent-400  text-white'
  if (ratio > 0.1)  return 'bg-accent-200  text-accent-900'
  return 'bg-accent-100 text-accent-800'
}

export default function MatrixCell({
  count = 0,
  xDimensionSlug,
  yDimensionSlug,
  xValueSlug,
  yValueSlug,
  previewEntries = [],
  maxCount = 1,
}) {
  const navigate = useNavigate()
  const classes = intensityClasses(count, maxCount)

  const handleClick = () => {
    if (count === 0) return
    const params = new URLSearchParams()
    params.set(`dimension[${xDimensionSlug}]`, xValueSlug)
    params.set(`dimension[${yDimensionSlug}]`, yValueSlug)
    navigate(`/catalog?${params.toString()}`)
  }

  const tooltipLines = [
    `${count} ${count === 1 ? 'entry' : 'entries'}`,
    ...previewEntries.slice(0, 5).map((t) => `• ${t}`),
  ]

  const ariaLabel = count > 0
    ? `${xValueSlug} × ${yValueSlug}: ${count} ${count === 1 ? 'entry' : 'entries'}`
    : `${xValueSlug} × ${yValueSlug}: no entries`

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={count === 0}
      title={tooltipLines.join('\n')}
      aria-label={ariaLabel}
      className={`relative flex h-14 w-14 items-center justify-center rounded-md text-sm font-semibold transition ${classes} ${
        count > 0 ? 'hover:ring-2 hover:ring-accent-300 cursor-pointer' : 'cursor-default'
      }`}
    >
      {count > 0 ? count : ''}
    </button>
  )
}
